import { InputGroup, Intent, Button, ListMenu, CustomLabel, } from "@focus/focusUI";
import React, { useContext, useState } from "react";
import { addGraph, createGraph, removeGraph } from "../models/graph";
import { PreGrafosConfig } from "../PreGrafosConfig";
import { PregrafosConfigurationContext } from "../PreGrafosConfig/PregrafosConfigurationContext";
import { getConfigGraphs } from "../models/plotConfig";
import "./GrafosConfig.scss";
import "./ListWithActions.scss";
import { getSelectedGraph } from "../utils";
export const GrafosConfigDialog = React.memo(({ config, onChange }) => {
    const initialValue = config.selectorFolderList[0].selectorList[0].tabs[0].graphs[0].id;
    const [graphId, setGraphId] = useState(initialValue);
    const [newGraphName, setNewGraphName] = useState("");
    const pltVariables = useContext(PregrafosConfigurationContext);
    const update = (newConfig) => {
        onChange(newConfig);
    };
    const createNewGraph = () => {
        const graph = createGraph(newGraphName, "Date", "", true);
        const newconfig = addGraph(config, graph);
        onChange(newconfig);
        setGraphId(graph.id);
    };
    const deleteGraph = (id) => {
        const newConfig = removeGraph(config, id);
        onChange(newConfig);
        if (id === graphId)
            setGraphId(undefined);
    };
    const graphs = getConfigGraphs(config);
    const selectedGraph = getSelectedGraph(config, graphId);
    return (React.createElement("div", { className: "focus-grafosConfig" },
        React.createElement("div", { className: "focus-grafosConfig_leftPanel" },
            React.createElement("div", null,
                React.createElement(CustomLabel, { text: "Available Graphs" }),
                React.createElement(ListMenu, { canRemove: true, canSelect: true, items: graphs, selectedItem: graphs.find((graph) => graph.id === graphId), itemRenderer: (graph) => graph.title, onSelect: (item) => setGraphId(item.id), onRemove: (item) => deleteGraph(item.id) })),
            React.createElement("div", null,
                React.createElement(CustomLabel, { text: "New Graph" },
                    React.createElement("form", { onSubmit: (e) => {
                            e.preventDefault();
                            createNewGraph();
                        } },
                        React.createElement(InputGroup, { onChange: (ev) => setNewGraphName(ev.target.value), role: "pregrafosAddName", placeholder: "New tab title...", value: newGraphName, rightElement: React.createElement(Button, { icon: "add", intent: Intent.SUCCESS, onClick: createNewGraph, disabled: newGraphName === "", role: "pregrafosAddIcon" }) }))))),
        React.createElement("div", null, selectedGraph && selectedGraph.id && (React.createElement(PreGrafosConfig, { pltVariables: pltVariables, config: config, graphId: graphId, onChange: update, selectedGraph: selectedGraph })))));
});
//# sourceMappingURL=GrafosConfigDialog.js.map